import { render, staticRenderFns } from "./mode_switch.vue?vue&type=template&id=6b3b7917"
import script from "./mode_switch.vue?vue&type=script&lang=js"
export * from "./mode_switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports